import { render, staticRenderFns } from "./BrandDrawerFilters.vue?vue&type=template&id=60201c04&scoped=true&"
import script from "./BrandDrawerFilters.vue?vue&type=script&lang=js&"
export * from "./BrandDrawerFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60201c04",
  null
  
)

export default component.exports